import { render, staticRenderFns } from "./BioCard.vue?vue&type=template&id=23a331d5&scoped=true"
import script from "./BioCard.vue?vue&type=script&lang=js"
export * from "./BioCard.vue?vue&type=script&lang=js"
import style0 from "./BioCard.vue?vue&type=style&index=0&id=23a331d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a331d5",
  null
  
)

export default component.exports